import Box2D from 'box2dweb'
const b2Vec2 = Box2D.Common.Math.b2Vec2
const b2RayCastOutput = Box2D.Collision.b2RayCastOutput
let playerBody
let enemyBody
let hittable = false
export default function loop(refs) {
  Object.keys(refs).forEach(r => {
    const { object, body } = refs[r]
    // handle position for development purpose
    if (body && object) {
      // if (object.userData.isPlayer && !playerBody) {
      //   playerBody = body
      //   const playerPos = playerBody.GetPosition()
      //   playerPos.x = 0
      //   playerPos.y = -4
      //   playerBody.SetTransform({ position: playerPos, GetAngle: () => playerBody.GetAngle() })
      // }
      // if (object.userData.isEnemy && !enemyBody) {
      //   enemyBody = body
      //   const enemyPos = enemyBody.GetPosition()
      //   enemyPos.x = -2
      //   enemyPos.y = 0
      //   enemyBody.SetTransform({ position: enemyPos, GetAngle: () => enemyBody.GetAngle() })
      // }

      const { impulse, rotate, spinSpeed = 2, originPosition, pickable, spinFactor } = body.GetUserData()
      
      let angle = body.GetAngle()
      
      const pos = body.GetPosition()
      if (impulse) {
        const power = 0.1// + body.GetLinearDamping() //+ body.GetFixtureList().GetDensity() * 0.1
        const direction = new b2Vec2(power * Math.cos(angle * Math.PI / 180), power * Math.sin(angle * Math.PI / 180))

        body.ApplyImpulse(direction, body.GetWorldCenter())
      }
      if (rotate) {
        angle = angle + (spinSpeed * spinFactor)
        if (angle > 360) {
          angle -= 360
        } else if (angle < -360) {
          angle += 360
        }
        body.SetTransform({ position: body.GetPosition(), GetAngle: () => angle })
      }
      // Apply Box2d props to Three object
      const newPos = { x: pos.x, y: object.position.y, z: pos.y };
      object.position.copy(newPos)

      object.rotation.y = (-angle * Math.PI / 180)
    }
  })
}